"use client";
// Imports

// Icon
export function CategoryIcon({ icon, size = 32, active = false }) {
  switch (icon) {
    case "default":
    case "attractions":
      return <DefaultIcon size={size} active={active} />;

    // Attractions
    // case "aggies-farm":
    //   return null;

    // case "animal":
    //   return null;

    // case "attractions":
    //   return null;

    // case "bar":
    //   return null;

    // case "carnival":
    //   return null;

    // case "celler-door":
    //   return null;

    // case "competition":
    //   return null;

    // case "dining":
    //   return null;

    // case "education":
    //   return null;

    // case "kids-carnival":
    //   return null;

    // case "lifestyle":
    //   return null;

    // case "live-entertainment":
    //   return null;

    // case "shopping":
    //   return null;

    // Facilities
    default:
      return <DefaultIcon size={size} active={active} />;
  }
}

function DefaultIcon({ size, active }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`transition-all duration-300 stroke-2 ${
        active
          ? "stroke-button-foreground"
          : "stroke-button group-hover:stroke-button-foreground"
      }`}
    >
      <line x1="21" x2="14" y1="4" y2="4" />
      <line x1="10" x2="3" y1="4" y2="4" />
      <line x1="21" x2="12" y1="12" y2="12" />
      <line x1="8" x2="3" y1="12" y2="12" />
      <line x1="21" x2="16" y1="20" y2="20" />
      <line x1="12" x2="3" y1="20" y2="20" />
      <line x1="14" x2="14" y1="2" y2="6" />
      <line x1="8" x2="8" y1="10" y2="14" />
      <line x1="16" x2="16" y1="18" y2="22" />
    </svg>
  );
}
